import { Box, Typography } from "@mui/material";
import { useTheme } from "../context/ThemeContext";
import { styledComponent } from "../utils/styled";

const OverlayRoot = styledComponent(Box)(({ isDark }) => ({
  position: "absolute",
  inset: 0,
  zIndex: 10,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: isDark ? "#90909033" : "#B3B3B366",
  pointerEvents: "none",
}));

const OverlayText = styledComponent(Typography)(({ isDark }) => ({
  fontFamily: "Inter",
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.04px",
  textAlign: "center",
  width: "180px",
  color: isDark ? "#A8AEB6" : "#434950",
}));

export default function ChatFileDropOverlay({ visible }) {
  const { isDark } = useTheme();
  if (!visible) return null;

  return (
    <OverlayRoot isDark={isDark}>
      <OverlayText isDark={isDark}>Add PDFs or supporting images</OverlayText>
    </OverlayRoot>
  );
}
